<template>
  <b-steps
    size="is-small"
    v-model="activeStep"
    :animated="true"
    :rounded="true"
    :has-navigation="true"
    label-position="bottom"
    mobile-mode="minimalist"
  >
    <b-step-item
      class="registration"
      step="1"
      label="規約の同意"
      :clickable="false"
    >
      <QualificationConfirmation v-model="qualification" />
    </b-step-item>
    <b-step-item
      class="registration"
      step="2"
      label="ログイン種別"
      :clickable="false"
    >
      <AuthProviderSelector @sign-in-success-event="onSignInSuccess($event)" />
    </b-step-item>
    <b-step-item
      class="registration"
      step="3"
      label="プロフィール"
      :clickable="false"
    >
      <RegistrationProfileSetting v-model="profileSetting" />
    </b-step-item>
    <b-step-item
      class="registration"
      step="4"
      label="プロフィール画像"
      :clickable="false"
    >
      <RegistrationProfileImage v-model="profileImage" />
    </b-step-item>
    <b-step-item class="registration" step="5" label="確認" :clickable="false">
      <RegistrationConfirmation :profileData="profileData" />
    </b-step-item>
    <template #navigation="{ previous, next }">
      <div class="formbuttons">
        <b-button
          v-if="activeStep != 0 && activeStep !== 2"
          outlined
          type="is-grey-light"
          :disabled="previous.disabled"
          @click.prevent="previous.action"
        >
          前へ
        </b-button>
        <b-button
          v-if="activeStep !== 1 && activeStep !== 4"
          outlined
          type="is-primary"
          :disabled="!canGoNext"
          @click.prevent="onNextButtonClicked(next)"
        >
          次へ
        </b-button>
        <b-button
          v-if="activeStep == 4"
          outlined
          type="is-primary"
          :disabled="!canSubmitRegistration"
          @click="submitRegistration"
        >
          登録
        </b-button>
      </div>
    </template>
  </b-steps>
</template>

<script>
import AuthProviderSelector from '@/components/Organisms/UserRegistrationFlowChildren/AuthProviderSelector';
import RegistrationProfileSetting from '@/components/Organisms/UserRegistrationFlowChildren/RegistrationProfileSetting';
import RegistrationProfileImage from '@/components/Organisms/UserRegistrationFlowChildren/RegistrationProfileImage';
import RegistrationConfirmation from '@/components/Organisms/UserRegistrationFlowChildren/RegistrationConfirmation';
import QualificationConfirmation from '@/components/Organisms/UserRegistrationFlowChildren/QualificationConfirmation';
import moment from 'moment';
import * as authService from '@/services/authServices';

export default {
  name: 'UserRegistrationFlow',
  components: {
    RegistrationProfileSetting,
    RegistrationProfileImage,
    RegistrationConfirmation,
    AuthProviderSelector,
    QualificationConfirmation
  },
  props: {
    isAuthCompleted: Boolean
  },
  created() {
    // TODO: 最初nullにしておいて、this.activeStepの状態がpropsで確定したら
    //     : 上記コンポーネントを表示するようにするとちらつきがなくなるかも。
    if (this.isAuthCompleted) {
      this.activeStep = 2;
      this.qualification.agreePolicies = true;
      const initialValues = authService.getInitialUserValueFromSocialAccount();
      this.email = initialValues?.email;
      this.profileSetting.nickname = initialValues?.nickname;
      this.profileImage.defaultPhotoUrl = initialValues.photoURL || '';
    }
  },
  computed: {
    canGoNext() {
      if (this.activeStep == 0) {
        return this.qualification.isValid;
      }
      if (this.activeStep == 2) {
        return this.profileSetting.isValid;
      }
      return true;
    },
    canSubmitRegistration() {
      return this.qualification.isValid && this.profileSetting.isValid;
    },
    profileData() {
      let previewPhotoUrl = this.profileImage.defaultPhotoUrl;
      if (this.profileImage.photoFile) {
        previewPhotoUrl = URL.createObjectURL(this.profileImage.photoFile);
      }
      return {
        photoURL: previewPhotoUrl,
        email: this.email,
        nickname: this.profileSetting.nickname,
        birthDate: this.qualification.birthDate,
        userType: this.profileSetting.userType
      };
    }
  },
  data() {
    return {
      activeStep: 0,
      qualification: {
        birthDate: moment('2000-12-25').toDate(), // 誕生日
        agreePolicies: false, // 規約へ同意しているかどうか
        isValid: false
      },
      profileSetting: {
        nickname: '', // ニックネーム
        userType: 'performer', // ユーザー種類
        isValid: false
      },
      profileImage: {
        photoFile: null, // プロフィール画像のファイルオブジェクト
        defaultPhotoUrl: null // はじめに表示する画像のURL
      },
      email: '' // メールアドレス
    };
  },
  methods: {
    async submitRegistration() {
      try {
        await this.$store.dispatch('createUser', {
          email: this.email,
          password: this.password,
          photoFile: this.profileImage.photoFile,
          defaultPhotoUrl: this.profileImage.defaultPhotoUrl,
          nickname: this.profileSetting.nickname,
          birthDate: this.qualification.birthDate,
          userType: this.profileSetting.userType
        });
        this.$router.push('/user/created');
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async onSignInSuccess(eventArgs) {
      try {
        this.activeStep = 2;

        const authResultUser = eventArgs.authResult.user;
        this.email = authResultUser.email;
        this.profileSetting.nickname = authResultUser.displayName;
        this.profileImage.defaultPhotoUrl = authResultUser.photoURL;
        this.$router.push('/signup/profile');
      } catch (err) {
        console.log(err);
        return;
      }
    },
    onNextButtonClicked(next) {
      if (this.activeStep == 0 && this.$store.state.auth.uid) {
        this.activeStep = 2;
      }
      next.action();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/signup-email.scss';
</style>
